import fetch from "isomorphic-fetch";
import { Endpoints } from "./definition";

// CONSTANTS ------------------------------------------------------------------

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// HELPERS --------------------------------------------------------------------

const createEndpointFactory =
  ({ createURL, method }) =>
  async ({ params = {}, token, payload, isForm = false }) => {
    const headers = {};
    if (!isForm) {
      headers["Content-Type"] = "application/json";
    }
    if (token) {
      headers.Authorization = `Basic ${token}`;
    }
    const url = createURL(params);
    const config = { method, headers };

    if (payload) {
      if (isForm) {
        config.body = payload;
      } else {
        config.body = JSON.stringify(payload);
      }
    }
    const res = await fetch(BACKEND_URL + url, config);

    if (res.ok) {
      if (res.status !== 204) {
        return await res.json();
      }
    } else {
      try {
        const message = (await res.json()).message;
        throw new Error(message);
      } catch (err) {
        throw new Error(err.message);
      }
    }
  };

export const API = {
  Webdav: {
    Upload: createEndpointFactory(Endpoints.Webdav.Upload),
  },
  Convention: {
    GetAll: createEndpointFactory(Endpoints.Convention.GetAll),
    Get: createEndpointFactory(Endpoints.Convention.Get),
    GetProducts: createEndpointFactory(Endpoints.Convention.GetProducts),
    Update: createEndpointFactory(Endpoints.Convention.Update),
    Delete: createEndpointFactory(Endpoints.Convention.Delete),
  },
  LiveConvention: {
    GetAll: createEndpointFactory(Endpoints.LiveConvention.GetAll),
    Get: createEndpointFactory(Endpoints.LiveConvention.Get),
    Update: createEndpointFactory(Endpoints.LiveConvention.Update),
    Delete: createEndpointFactory(Endpoints.LiveConvention.Delete),
  },
  Login: createEndpointFactory(Endpoints.Login),
  Product: {
    GetAll: createEndpointFactory(Endpoints.Product.GetAll),
    Get: createEndpointFactory(Endpoints.Product.Get),
    Update: createEndpointFactory(Endpoints.Product.Update),
    Delete: createEndpointFactory(Endpoints.Product.Delete),
  },
  Wishlist: {
    GetAll: createEndpointFactory(Endpoints.Wishlist.GetAll),
    Get: createEndpointFactory(Endpoints.Wishlist.Get),
    Add: createEndpointFactory(Endpoints.Wishlist.Add),
    Remove: createEndpointFactory(Endpoints.Wishlist.Remove),
    Create: createEndpointFactory(Endpoints.Wishlist.Create),
    Delete: createEndpointFactory(Endpoints.Wishlist.Delete),
  },
};
